import React from 'react';
import { Play, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from '../shared/Button';
export function VSLHero() {
  return <section className="relative w-full bg-[#0a0a0a] pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-2471">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-[#3ab795] opacity-10 blur-[120px] rounded-full pointer-events-none" data-id="element-2472" />

      <div className="max-w-5xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-2473">
        {/* Logo - Centered */}
        <div className="mb-12 flex justify-center w-full" data-id="element-2474">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dxuXv5AoswiCCU7F4ucVPA/AcquireFlow_Logo_%287%29.svg" alt="AcquireFlow" className="h-10 md:h-12 opacity-90 mx-auto" data-id="element-2475" />
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-tight mb-6 max-w-4xl" data-id="element-2476">
          Send 1,000+ MLS Offers <br className="hidden md:block" data-id="element-2477" />
          <span className="text-[#3ab795] relative inline-block" data-id="element-2478">
            Per Day On Autopilot
            <svg className="absolute w-full h-3 -bottom-1 left-0 text-[#3ab795] opacity-40" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-2479">
              <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-2480" />
            </svg>
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-2xl text-[#b8bcc8] max-w-2xl mb-10 leading-relaxed" data-id="element-2481">
          Most investors analyze 5 deals a day.{' '}
          <br className="hidden sm:block" data-id="element-2482" />
          Our clients send{' '}
          <span className="text-white font-semibold" data-id="element-2483">1,000+ offers</span> and
          let math do the work.
        </p>

        {/* Video Placeholder */}
        <div className="w-full max-w-4xl aspect-video bg-[#1a1a1a] rounded-2xl border border-white/10 shadow-[0_0_40px_rgba(0,0,0,0.5)] relative group cursor-pointer overflow-hidden mb-12" data-id="element-2484">
          {/* Thumbnail / Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/40 flex flex-col items-center justify-center" data-id="element-2485">
            <div className="w-20 h-20 md:w-24 md:h-24 bg-[#3ab795] rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(58,183,149,0.4)] group-hover:scale-110 transition-transform duration-300" data-id="element-2486">
              <Play className="w-8 h-8 md:w-10 md:h-10 text-white fill-white ml-1" data-id="element-2487" />
            </div>
            <p className="mt-6 text-white font-semibold text-lg md:text-xl px-4 drop-shadow-md" data-id="element-2488">
              How Investors Are Pulling 1–3 Deals Per Month Directly From The
              MLS
            </p>
          </div>
          {/* Placeholder for actual video embed */}
          <div className="absolute bottom-4 right-4 bg-black/60 px-3 py-1 rounded text-white text-sm font-medium backdrop-blur-sm" data-id="element-2489">
            07:42
          </div>
        </div>

        {/* Primary CTA */}
        <div className="flex flex-col items-center gap-4 w-full max-w-md" data-id="element-2490">
          <Button variant="primary" size="lg" fullWidth className="text-lg py-6 shadow-[0_0_30px_rgba(58,183,149,0.3)] hover:shadow-[0_0_40px_rgba(58,183,149,0.5)] transform hover:-translate-y-1 transition-all duration-300" href="https://calendly.com/acquireflow/strategy" // Placeholder link
        data-id="element-2491">
            Book A Strategy Call
            <ArrowRight className="w-5 h-5 ml-2" data-id="element-2492" />
          </Button>
          <p className="text-sm text-[#6b7280] font-medium flex items-center gap-2" data-id="element-2493">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-2494" />
            Spots are limited. Serious investors only.
          </p>
        </div>

        {/* Social Proof / Trust */}
        <div className="mt-16 pt-8 border-t border-white/5 w-full max-w-4xl flex flex-wrap justify-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-2495">
          {['Investorlift', 'BatchLeads', 'Subto'].map(brand => <span key={brand} className="text-xl font-bold text-white/40 uppercase tracking-wider" data-id="element-2496">
              {brand}
            </span>)}
        </div>
      </div>
    </section>;
}